import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function HomePage() {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-black/70 z-10"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/images/background.jpeg')"
          }}
        ></div>
        <div className="relative z-20 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            QBI Floor
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-stone-200">
            Professioneller Parkettleger in Deutschland
          </p>
          <p className="text-lg md:text-xl mb-12 text-stone-300 max-w-2xl mx-auto">
            Hochwertige Parkettböden für Ihr Zuhause. Von der Beratung bis zur fertigen Verlegung - 
            wir bringen Eleganz und Qualität in Ihre Räume.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="bg-stone-600 hover:bg-stone-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300"
            >
              Kostenlose Beratung
            </Link>
            <a 
              href="#services" 
              className="border-2 border-white text-white hover:bg-white hover:text-stone-800 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300"
            >
              Unsere Leistungen
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stone-800 mb-4">
              Unsere Leistungen
            </h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              Von der ersten Beratung bis zur fertigen Verlegung - wir sind Ihr Partner für hochwertige Parkettböden
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-stone-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-stone-200 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-stone-800 mb-4">Beratung & Planung</h3>
              <p className="text-stone-600">
                Professionelle Beratung bei der Auswahl des richtigen Parketts. Wir helfen Ihnen bei der Materialauswahl, 
                Farbgebung und Verlegemuster.
              </p>
            </div>
            
            <div className="bg-stone-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-stone-200 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-stone-800 mb-4">Professionelle Verlegung</h3>
              <p className="text-stone-600">
                Präzise und saubere Verlegung nach höchsten Standards. Von Massivparkett bis Fertigparkett - 
                wir beherrschen alle Verlegetechniken.
              </p>
            </div>
            
            <div className="bg-stone-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-stone-200 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-stone-800 mb-4">Renovierung & Pflege</h3>
              <p className="text-stone-600">
                Verlängern Sie die Lebensdauer Ihres Parkettbodens. Wir bieten Schleifen, 
                Versiegeln und regelmäßige Pflege für ein dauerhaft schönes Ergebnis.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-stone-100">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-stone-800 mb-6">
                Über QBI Floor
              </h2>
              <p className="text-lg text-stone-600 mb-6">
                Seit über 15 Jahren sind wir Ihr zuverlässiger Partner für hochwertige Parkettböden. 
                Unser erfahrenes Team kombiniert traditionelle Handwerkskunst mit modernster Technik.
              </p>
              <p className="text-lg text-stone-600 mb-8">
                Wir legen Wert auf Qualität, Pünktlichkeit und Kundenzufriedenheit. 
                Jedes Projekt wird individuell geplant und sorgfältig ausgeführt.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-stone-800">500+</div>
                  <div className="text-stone-600">Zufriedene Kunden</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-stone-800">15+</div>
                  <div className="text-stone-600">Jahre Erfahrung</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div 
                className="h-96 rounded-lg bg-cover bg-center"
                style={{
                  backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxyZWN0IHg9IjI1MCIgeT0iMjUwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIiBmaWxsPSIjRkZGRkZGIi8+CjxyZWN0IHg9IjI3MCIgeT0iMjcwIiB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHRyYW5zZm9ybT0icm90YXRlKDQ1KSIgZmlsbD0iI0Y1RjVGNSIvPgo8cmVjdCB4PSIyODAiIHk9IjI4MCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSkiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3QgeD0iMjkwIiB5PSIyOTAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIiBmaWxsPSIjRjVGNUY1Ii8+CjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI2MDAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3QgeD0iMCIgeT0iMjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1NjAiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3QgeD0iNTgwIiB5PSIyMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjU2MCIgZmlsbD0iI0ZGRkZGRiIvPgo8cmVjdCB4PSIwIiB5PSI1ODAiIHdpZHRoPSI2MDAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjRjVGNUY1Ii8+CjxyZWN0IHg9IjU4MCIgeT0iMCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjRjVGNUY1Ii8+CjxyZWN0IHg9IjAiIHk9IjU4MCIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjRjVGNUY1Ii8+CjxyZWN0IHg9IjU4MCIgeT0iNTgwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRkZGRkYiLz4KPHJlY3QgeD0iMjk1IiB5PSIyMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjU2MCIgZmlsbD0iI0Y1RjVGNSIvPgo8cmVjdCB4PSIzMDUiIHk9IjIwIiB3aWR0aD0iMTAiIGhlaWdodD0iNTYwIiBmaWxsPSIjRkZGRkZGIi8+CjxyZWN0IHg9IjAiIHk9IjI5NSIgd2lkdGg9IjYwMCIgaGVpZ2h0PSIxMCIgZmlsbD0iI0Y1RjVGNSIvPgo8cmVjdCB4PSIwIiB5PSIzMDUiIHdpZHRoPSI2MDAiIGhlaWdodD0iMTAiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+')"
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-stone-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold mb-6">
            Bereit für Ihren neuen Parkettboden?
          </h2>
          <p className="text-xl text-stone-300 mb-8">
            Kontaktieren Sie uns für eine kostenlose Beratung und ein unverbindliches Angebot
          </p>
          <Link 
            to="/contact" 
            className="bg-stone-600 hover:bg-stone-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 inline-block"
          >
            Jetzt Kontakt aufnehmen
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
} 